import React, {useEffect, useMemo, useState} from 'react'
import {Button} from "../button";
import {Typography} from "../../styles/typography";
import {Colors} from "../../styles/colors";
import {Spacing} from "../../styles/spacing";
import {css} from "@emotion/react";
import {useMixpanel} from "../../hooks/useMixpanel";
import {createLead} from "../../services/lead";
import {StyledInput} from "./components";
import exitIntentPhone from '../../images/exit-intent-phone.svg'
import closeIcon from '../../images/icons/close.svg'
import {useCountdown} from "../../hooks/useCountdown";
import {SiteLink} from "../SiteLink";
import {trackEvent} from "../../utils/tracking";

const MODAL_ENGAGE_DELAY = 1000

const modalContainer = css`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, .3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`
const modal = css`
  position: relative;
  width: 600px;
  border-radius: 12px;
  ${Colors.BackgroundColor.eerieBlack0}
  z-index: 10001;
  animation: fadeIn 300ms;

  img.animated {
    animation: fadeIn 500ms;
    animation-delay: 200ms;
    animation-fill-mode: forwards;
    opacity: 0;
    transform: translateY(-100px);
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(-100px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .tate-call-me-drawer-success {
    padding: 12px 11px;
    background: #D8F5E8;
    border: 1px solid #65D9A5;
    box-sizing: border-box;
    border-radius: 4px;
    font-weight: 600;
    font-size: 14px;
    line-height: 150%;
    letter-spacing: -0.1px;
    color: #2F9B6B;
  }
`
const exitIntentImage = css`
  position: absolute;
  bottom: -78px;
  right: -90px
`

const MODAL_TESTS = [
  [
    "Hey aspetta!",
    "Non ti va di leggere?",
    "Parliamone a voce, senza impegno"
  ],
  [
    "Hey, non salutarci già!",
    "Facciamo due chiacchiere?",
    "Ti richiamiamo noi senza impegno"
  ]
]

export const ExitIntentPhoneNumber = () => {
  const [open, setOpen] = useState(false)
  const [variant] = useState(Math.round(Math.random()))
  const [loading, setLoading] = useState(false)
  const [phone, setPhone] = useState('')
  const isValid = useMemo(() => phone?.length > 0 ? /^\d+$/i.test(phone) : null, [phone])
  const mixpanel = useMixpanel()
  const [seconds, startCountdown] = useCountdown()

  const onSubmit = async () => {
    if (isValid === true) {
      setLoading(true)
      try {
        const {status} = await createLead({
          phone: phone,
          tags: ['exit_intent_popup']
        })
        if (status === 200) {
           trackEvent('website:contact_sent', {
            tags: ['exit_intent_popup'],
            type: 'phone',
            textVariant: variant + 1
          })
          startCountdown(10)
        }
      } finally {
        setLoading(false)
      }
    }
  }

  const toggle = (event) => {
    if (event.target.id === 'modal-container') {
      setOpen(false)
    }
  }
  useEffect(() => {
    let timeout

    const onMouseEnter = () => {
      if (timeout) {
        clearTimeout(timeout)
        timeout = undefined
      }
      document.removeEventListener('mouseenter', onMouseEnter)
      document.addEventListener('mouseleave', onMouseLeave)
    }
    const onMouseLeave = () => {
      if(process.env.NODE_ENV==='development') return
      timeout = setTimeout(() => {
        trackEvent('website:exit-intent_shown')
        if (sessionStorage.getItem('exit_intent_phone_modal_shown') !== 'true') {
          setOpen(true)
          sessionStorage.setItem('exit_intent_phone_modal_shown', 'true')
        }
      }, MODAL_ENGAGE_DELAY)
      document.removeEventListener('mouseleave', onMouseLeave)
      document.addEventListener('mouseenter', onMouseEnter)
    }
    document.addEventListener('mouseleave', onMouseLeave)

    return () => {
      clearTimeout(timeout)
      document.removeEventListener('mouseleave', onMouseLeave)
    }
  }, [])

  if (!open) return null
  return (
    <div css={[modalContainer]} onClick={toggle} id={'modal-container'}>
      <div
        css={[Spacing.Padding.horizontal_54, modal, Spacing.Text.center, Spacing.Padding.top_56, css`padding-bottom: 160px`]}>
        <div css={[Spacing.Text.right, Typography.style.pointer]} onClick={() => setOpen(false)}>
          <img src={closeIcon} alt="close"/>
        </div>
        <h2 css={[Typography.heading.h3_700]}>{MODAL_TESTS[variant][0]}</h2>
        <h3 css={[Typography.heading.h3_700, Colors.Color.violetBlue500]}>{MODAL_TESTS[variant][1]}</h3>
        <h5 css={[Typography.paragraph.p1_400, Spacing.Margin.bottom_24]}>{MODAL_TESTS[variant][2]}</h5>

        {
          seconds > 0 &&
          <div className='tate-call-me-drawer-success'>Perfetto, ti richiameremo presto. Grazie!</div>
        }
        {
          seconds < 1 &&
          <div css={[css`display: flex;
            width: 400px;
            margin: 0 auto`]}>
            <StyledInput css={[css`min-height: 54px; padding-left: 16px`]}
                         placeholder="Numero di telefono"
                         data-style={'grey'}
                         type="tel" value={phone} onChange={evt => setPhone(evt.target.value)}/>
          </div>
        }

        <p css={[Typography.label.label4_400, Spacing.Margin.top_16, Colors.Color.eerieBlack600]}>Inserendo il tuo
          numero di telefono, accetti la <SiteLink to={"/legal/privacy-policy"} name={'privacy policy'}>privacy policy</SiteLink> di Tate
        </p>
        <Button limit css={[Spacing.Margin.top_24]} onClick={onSubmit} disabled={loading}>
          <span css={[Typography.heading.h6_600]}>
          {loading ? 'Attendi...' : 'Chiamatemi'}
          </span>
        </Button>

        <img className={'animated'} css={[exitIntentImage]} src={exitIntentPhone} width={456} height={309} alt=""/>
      </div>
    </div>
  )
}
